import {HTTP} from '../sbcore/http-common.js'
// import {getProductObject} from '../sbcore/sbcore.js'

let site = require(process.env.VUE_APP_SITE_JS)

export default class SB {
  errors  = []
    uuid = ""
    serverURL = site.serverURL
    viewed = []
    products = (sessionStorage.shopbox_products==undefined) ? {} : JSON.parse(sessionStorage.shopbox_products)
    history = (sessionStorage.shopbox_history==undefined) ? [] : JSON.parse(sessionStorage.shopbox_history)
    controlGroup = true
    init (success) {
      // First take care of the UUID
        if (localStorage.shopbox_uuid==undefined) {
          localStorage.shopbox_uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, 
          function(c) {
              var r = (crypto.getRandomValues(new Uint8Array(1))[0]+(new Date().getTime()))%16|0, v = c == 'x' ? r : (r&0x3|0x8);
              return v.toString(16)//+'.'+(+new Date());
          });
        } 

        this.uuid = localStorage.shopbox_uuid

        if (!site.badUUID(this.uuid) && !site.badDomain()) {

          if (!sessionStorage.shopbox_usergroup) {

            // now do the same for the flags
            if (localStorage.shopbox_flags==undefined) {
              localStorage.shopbox_flags = Math.floor(Math.random()*10).toString()
            }

            let postData = {}
            // If thereare no mobile widgets and the device is movile then the controlgroup should be true. This is done by sending -2 to server
            if (site.availableMobileWidgets.length > 0) {
              postData = {'uuid':this.uuid,'group':localStorage.shopbox_flags}
            } else {
              if (this.smallScreen()) {
                postData = {'uuid':this.uuid,'group':'-2'}
              } else {
                postData = {'uuid':this.uuid,'group':localStorage.shopbox_flags}
              }
            }

            HTTP.post(`${this.serverURL}/sendevent/usergroup`,postData,{headers:{'clientID':site.clientID}})
              .then(response=>{
                // Store in session storage to save later calls
                sessionStorage.shopbox_usergroup = JSON.stringify(response.data)
                success(response.data.control_group)
                // if (response.data.control_group == response.data.control_group) {
                //     success(1)
                // }

              })
              .catch(e => {
                this.errors.push(e)
              }) 

          } else {
            if (success != undefined) {success(JSON.parse(sessionStorage.shopbox_usergroup)['control_group'])}
          }
        } else {
          success(1)      // force into control group
        }


    }

    // smallScreen () {return (window.screen.width < 768 || window.screen.height < 768)}
    smallScreen () {return (window.screen.width <= 768)}



    getWelcomeProducts (number,page,success) {
      let edata = {'uuid':this.uuid,'site':site.sitecode,'noProducts':number,'page':page}
      HTTP.post(`${this.serverURL}/getsbwelcome`,edata,{headers:{'clientID':site.clientID}})
      .then(response=>{
        if (site.debug) {
          console.log('response',response)
        }
        success(response.data['prodList'])
      })
      .catch(e => {
        this.errors.push(e)
      })  
    }

    getCrossSellProducts (cartList,number,success) {
      let edata = { 'uuid':this.uuid,
                    'site':site.sitecode,
                    'numProducts':number,
                    'productList':cartList}
      HTTP.post(`${this.serverURL}/crosssell`,edata,{headers:{'clientID':site.clientID}})
      .then(response=>{
        success(response.data.crossSell)
      })
      .catch(e => {
        this.errors.push(e)
      })  
    }


    getProductObject (productid,success) {
      if (this.products[productid] == undefined) {
        this.getProductDetails(productid,(newProduct) => {
        this.products[productid] = newProduct
        sessionStorage.shopbox_products = JSON.stringify(this.products)
        success(newProduct)
        })
      } else {
        success(this.products[productid])
      }
    }

    getProductDetails(product,f) {
        HTTP.get(`${this.serverURL}/productdetails?productid=${encodeURIComponent(product)}`,{headers:{'clientID':site.clientID}})
          .then((responseStr)=>{

              let rdata = {}
              if (typeof(responseStr.data)=='object') {
                rdata = responseStr.data
              } else {
                rdata = JSON.parse(responseStr.data.replace(/\bNaN\b/g, '""'))
              }

              let product = {
                // productid : response.data._id,
                productid : (rdata._id == undefined) ? rdata.sku : rdata._id,
                line1 : rdata.name,
                price : rdata.price,
                image : rdata.imageUrl,
                href : rdata.url
              } 

              if (site.sitecode=='petstop') {
                // product.href = 'https://www.petstop.ie/'+product.href
                product.price = rdata.display_price
              }

              // let product = {
              //   productid : (response.data._id == undefined) ? response.data.sku : response.data._id,
              //   line1 : response.data.name,
              //   price : response.data.price,
              //   image : response.data.imageUrl,
              //   href : response.data.url
              // } 
              f(product)
        }).catch(e => {
            console.log(e)
            this.errors.push(e)
        })  
          
    }

    sendEvent (event,data) {
      // If the right event type, save locally
      // if (['search','detail','sbaction'].includes(event)) {
      //   this.history.push({'event':event,'data':data})
      //   sessionStorage.shopbox_history = JSON.stringify(this.history)
      // }

      if (!site.badUUID(this.uuid) && !site.badDomain()) {
        if (this.smallScreen() && Object.values(data).indexOf('source')) {
          data.source = 'm'+data.source
        }

        let edata = {"uuid":this.uuid,"site":site.sitecode,...data
                  }

        HTTP.post(`${this.serverURL}/sendevent/${event}`,edata,{headers:{'clientID':site.clientID}})
        .then(response=>{
            this.pin = response.data.pin
        })
        .catch(e => {
          this.errors.push(e)
        })  

      }

    }


    getSimilarProducts(seed,n,e,brandConstraint,f) {
      let data = {productid : seed.productid,
            numProducts : n,
            excludeHistory : e,
            uuid : this.uuid,
            site : site.sitecode,
            priceR : 90,
            brandR : brandConstraint}
      
      HTTP.post(`${this.serverURL}/getsimilarproducts`,data,{headers:{'clientID':site.clientID}})
      .then(response=>{
        f(response.data.current,response.data.history)
      })
      .catch(e => {
        this.errors.push(e)
        f([])
      })  
    }


    // getProductObject (product) {
    //   console.log('getProductObject',product)
    //   if (this.products[product.productid] == undefined) {
    //     this.products[product.productid] = product
    //   }

    //   return this.products[product.productid]
    // }

    panelWidth (percent,panels) {
      // percent is the amoutn of space available for panels
      return ((percent/panels)-1).toString()+'%'
    }

    getUrlVars() {
        let vars = {};
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
            vars[key] = value;
        });
        return vars;
    }

}